import version from './src/version'
import HTTable from "./src/HTTable" 
import ETTable from "./src/EVirtTable"


const components = [
  HTTable,
  ETTable,
];

const install = function(Vue,option={}) {
    components.map(component => {
      Vue.use(component);
    });
    const defaultConfig = {
      isShowHelp: false, // 是否在控制台输出组件使用规则  默认值 false 表示不显示组件使用规则
    }
    const tempOption = Object.assign({},defaultConfig,option)
    console.log(version);
    if(tempOption.isShowHelp){
      console.log(` `);
    }
  };
  
  /* istanbul ignore if */
  if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }
  
  export {
    version,
    install,
    HTTable,
  };
  
  export default {
    version,
    install,
  };
  